import styled from 'styled-components';

export const Container = styled.div`
  .card-shadow {
    box-shadow: 0 0.25rem 0.75rem rgb(0 0 0 / 5%);
  }

  .active-services-bg {
    background-color: ${(props) => props.theme.$bg_gray};
  }

  .active-services-wave {
    height: 100%;
    width: 100%;
    display: flex;
    position: relative;
  }

  .active-services-wave-img {
    height: 100%;
    position: absolute;
    left: -14%;
  }

  .active-services-wave-bg {
    background: #66a33c;
    height: 100%;
    width: 100%;
    padding: 5rem 3rem;
  }

  .list-with-check {
    list-style: none;
    margin: 2rem 0;
    padding: 0;
  }

  .list-with-check li {
    margin: 1rem 0;
  }

  .list-with-check span {
    color: ${(props) => props.theme.$primary_green};
  }
`;
